import { Link } from "react-router-dom";
import { Users, ExternalLink } from "lucide-react";
import { DataTable, MetricCard, SectionHeading, ngn, usd, shortDate } from "./ui";

export default function FilmmakerOverview({ data }) {
  const rows = data?.rows || [];
  const sum = (k) => rows.reduce((a, r) => a + (r.earnings?.[k] || 0), 0);
  return (
    <section data-testid="filmmaker-overview">
      <SectionHeading eyebrow="Creators" title="Filmmaker overview" description="Each filmmaker's 70% earnings by stream, films uploaded, followers and public profile." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <MetricCard label="Registered filmmakers" value={(data?.total || 0).toLocaleString()} icon={Users} testId="fmo-total" />
        <MetricCard label="Creator earnings · ₦" value={ngn(sum("rentals_ngn") + sum("watch_party_ngn") + sum("donations_ngn"))} hint="Rentals + Watch Party + donations" testId="fmo-earnings-ngn" />
        <MetricCard label="Creator earnings · $" value={usd(sum("rentals_african_usd_cents") + sum("rentals_diaspora_usd_cents") + sum("watch_party_usd_cents") + sum("donations_usd_cents"))} hint="African + Diaspora + Watch Party + donations" testId="fmo-earnings-usd" />
        <MetricCard label="Films uploaded" value={rows.reduce((a, r) => a + r.films_count, 0).toLocaleString()} testId="fmo-films" />
      </div>
      <DataTable
        testId="filmmaker-overview-table"
        headers={["Filmmaker", "Joined", "Films", "Followers", "Rentals ₦", "African $", "Diaspora $", "Watch Party", "Donations", "Profile"]}
        empty={rows.length === 0 ? "No filmmakers registered yet." : null}
      >
        {rows.map((r) => (
          <tr key={r.id} className="hover:bg-white/[0.02]" data-testid={`fmo-row-${r.id}`}>
            <td className="p-3">
              <p className="font-medium">{r.name || "—"}</p>
              <p className="text-xs text-foreground/45">{r.email}</p>
            </td>
            <td className="p-3 text-xs text-foreground/55 whitespace-nowrap">{shortDate(r.joined_at)}</td>
            <td className="p-3 tabular-nums">{r.films_count}</td>
            <td className="p-3 tabular-nums" data-testid={`fmo-followers-${r.id}`}>{r.follower_count}</td>
            <td className="p-3 tabular-nums">{ngn(r.earnings.rentals_ngn)}</td>
            <td className="p-3 tabular-nums">{usd(r.earnings.rentals_african_usd_cents)}</td>
            <td className="p-3 tabular-nums">{usd(r.earnings.rentals_diaspora_usd_cents)}</td>
            <td className="p-3 tabular-nums whitespace-nowrap">{ngn(r.earnings.watch_party_ngn)} · {usd(r.earnings.watch_party_usd_cents)}</td>
            <td className="p-3 tabular-nums whitespace-nowrap">{ngn(r.earnings.donations_ngn)} · {usd(r.earnings.donations_usd_cents)}</td>
            <td className="p-3">
              {r.handle ? (
                <Link to={`/@${r.handle}`} className="inline-flex items-center gap-1 text-terracotta hover:text-ember text-xs font-mono whitespace-nowrap" data-testid={`fmo-profile-${r.id}`}>
                  @{r.handle} <ExternalLink className="w-3 h-3" />
                </Link>
              ) : "—"}
            </td>
          </tr>
        ))}
      </DataTable>
    </section>
  );
}
